<template>
    <div>
        <m-assembly-table ref='pageForm'
            :formData='formData'
            :columns='columns'
            :data='tableData'
            :tableButtons='tableButtons'
            :loading='loading'
            :currentPage='settings.currentPage'
            :pageSize='settings.pageSize'
            :total='settings.total'
            :settings='settings'
            @onSubmit='onSubmit'
            @onPageSizeChange='onPageSizeChange'
            @onCurrentPageChange='onPageChange'
        >
        </m-assembly-table>

        <Modal 
            v-model="updatePriceModal.show"
            :title="$t('gscInvoice.t25')"
            :width="400"
        >
            <Form :model="updatePriceModal.form" label-position="right" :label-width="80" :rules="updatePriceModal.rules"
                    ref="updatePriceForm">
                <FormItem :label="$t('gscInvoice.t1')" prop="orgId">
                    <Select filterable v-model="updatePriceModal.form.orgId" clearable @on-change="changeOU">
                        <Option v-for="item in ouList" :value="item.value" :key="item.label">{{ item.label }}</Option>
                    </Select>
                </FormItem>
                <!-- <FormItem :label="$t('gscInvoice.t28')" prop="vendorSiteId">
                    <Select v-model="updatePriceModal.form.vendorSiteId" clearable>
                        <Option v-for="item in siteList" :value="item.value" :key="item.label">{{ item.label }}</Option>
                    </Select>
                </FormItem>
                <FormItem :label="$t('gscInvoice.t29')" prop="currencyCode">
                    <Select v-model="updatePriceModal.form.currencyCode" clearable>
                        <Option v-for="item in currencyList" :value="item.value" :key="item.label">{{ item.label }}
                        </Option>
                    </Select>
                </FormItem> -->
            </Form>
            <div slot="footer">
                <Button type="default" @click="updatePriceModal.show = false" style="margin-right:10px;">{{$t('gscInvoice.t31')}}</Button>
                <Button type="primary" :loading="updatePriceModal.loading" @click="updatePriceConfirm">{{$t('gscInvoice.t18') }}</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import axios from 'axios';
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
import {getOuList, exportExcel, queryIntTimeZone} from './financialAccounting';
import moment from 'moment';
export default {
    name: 'gscInvoice',
    components: { 
        mAssemblyTable 
    },
    data () {
        return {
            formData: {
                row: 3,
                items: [
                    {
                        value: '',
                        field: 'orgId', // 买方
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {
                            change: (val) => {
                            }
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        title: this.$t('gscInvoice.t1'),
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('common.not_empty_require')
                            }
                        }
                    },
                    {
                        value: '',
                        field: 'invoiceType', // 开票类型
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {},
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        title: this.$t('gscInvoice.t2')
                    },
                    {
                        value: '',
                        field: 'status', // 单号状态
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {},
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        title: this.$t('gscInvoice.t3')
                    },
                    {
                        value: '',
                        field: 'startDate',  // GSC发票日期
                        layout: {
                            row: 2,
                            span: 8,
                            offset: 0
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd'
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: this.$t('gscInvoice.t4'),
                        placeholder: '',
                        isDouble: true
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'endDate',
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd',
                            options: {
                                disabledDate(date) {
                                }
                            }
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: ''
                    },
                    {
                        value: '',
                        field: 'tcmStartDate',  // 税控发票日期
                        layout: {
                            row: 2,
                            span: 8,
                            offset: 0
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd'
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: this.$t('gscInvoice.t5'),
                        placeholder: '',
                        isDouble: true
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'tcmEndDate',
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd',
                            options: {
                                disabledDate(date) {
                                }
                            }
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: ''
                    },
                    {
                        value: '',
                        field: 'ispInvoiceCode', // GSC发票编号
                        disabled: false,
                        validators: {
                            required: {
                                required: false
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('gscInvoice.t6')
                    },
                    {
                        value: '',
                        field: 'taxInvoiceNumber', // 税控发票号
                        disabled: false,
                        validators: {
                            required: {
                                required: false
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('gscInvoice.t7')
                    }
                ]
            },
            columns: {
                columns: [
                    {
                        title: this.$t('gscInvoice.t6'), // GSC发票编号
                        align: 'center',
                        minWidth: 130,
                        key: 'ispInvoiceCode',
                        render: (h, params) => {
                            let {ispInvoiceCode, ispInvoiceId} = params.row;
                            return h('span', {
                                style: {
                                    color: '#3aa2eb',
                                    cursor: 'pointer'
                                },
                                on: {
                                    click: () => {
                                        this.$router.push({
                                            name: 'gscInvoiceDetail',
                                            query: {
                                                ispInvoiceId
                                            }
                                        });
                                    }
                                }
                            }, ispInvoiceCode)
                        }
                    },
                    {
                        title: this.$t('gscInvoice.t7'), // 税控发票号
                        align: 'center',
                        minWidth: 110,
                        key: 'taxInvoiceNumber'
                    },
                    {
                        title: this.$t('gscInvoice.t8'), // 供应商地点
                        align: 'center',
                        minWidth: 110,
                        key: 'vendorSiteCode'
                    },
                    {
                        title: this.$t('gscInvoice.t9'), // 创建日期
                        align: 'center',
                        minWidth: 130,
                        key: 'creationDate',
                        render: (h, params) => {
                            let {creationDate} = params.row;
                            return h('span', creationDate && moment(creationDate).add(this.offsetTime, 'h').format('YYYY-MM-DD HH:mm:ss') || '');
                        }
                    },
                    {
                        title: this.$t('gscInvoice.t10'), // GSC发票类型 
                        align: 'center',
                        minWidth: 110,
                        key: 'invoiceType',
                        render: (h, params) => {
                            let {invoiceType} = params.row;
                            return h('span', invoiceType && this.INT_GSC_INVOICE_SOURCE_TYPE.find((item) => item.code === invoiceType).label);
                        }
                    },
                    {
                        title: this.$t('gscInvoice.t11'), // GSC发票状态
                        align: 'center',
                        minWidth: 110,
                        key: 'status',
                        render: (h, params) => {
                            let {status} = params.row;
                            return h('span', status && this.INT_GSC_INVOICE_STATUS.find((item) => item.value === status).label);
                        }
                    },
                    // {
                    //     title: this.$t('gscInvoice.t12'), // 入账日期
                    //     align: 'center',
                    //     minWidth: 110,
                    //     key: ''
                    // },
                    {
                        title: this.$t('index.biddingPrice.fields.DismissReason'), // 驳回原因
                        minWidth: 150,
                        key: 'rejectReason',
                        tooltip: true,
                    },
                    {
                        title: this.$t('gscInvoice.t13'), // 不含税金额
                        align: 'center',
                        minWidth: 110,
                        key: 'noTaxAmount'
                    },
                    {
                        title: this.$t('gscInvoice.t14'), // 税率
                        align: 'center',
                        minWidth: 110,
                        key: 'taxRate'
                    },
                    // {
                    //     title: this.$t('gscInvoice.t15'), // 税额
                    //     align: 'center',
                    //     minWidth: 110,
                    //     key: 'taxAmount'
                    // },
                    {
                        title: this.$t('gscInvoice.t16'), // 含税金额
                        align: 'center',
                        minWidth: 110,
                        key: 'totalAmount'
                    },
                    {
                        title: this.$t('gscInvoice.t17'), // 币种
                        align: 'center',
                        minWidth: 110,
                        key: 'currencyCode'
                    },
                    {
                        title: this.$t('gscInvoice.t18'), // 提交
                        align: 'center',
                        minWidth: 50,
                        fixed: 'right',
                        key: 'invaccNum',
                        render: (h, params) => {
                            let {ispInvoiceId, status} = params.row;
                            return h('Button', {
                                props: {
                                    type: 'text',
                                    icon: 'checkmark',
                                    disabled: !['New', 'Rejected'].includes(status)
                                },
                                on: {
                                    click: () => {
                                        this.submitIsp(ispInvoiceId);
                                    }
                                }
                            });
                        }
                    },
                    // {
                    //     title: this.$t('gscInvoice.t19'), // 修改
                    //     align: 'center',
                    //     minWidth: 110,
                    //     fixed: 'right',
                    //     key: 'invaccNum',
                    //     render: (h, params) => {
                    //         let {ispInvoiceId, status} = params.row;
                    //         return h('Button', {
                    //             props: {
                    //                 type: 'text',
                    //                 icon: 'edit',
                    //                 disabled: !['New', 'Rejected'].includes(status)
                    //             },
                    //             on: {
                    //                 click: () => {
                    //                     this.$router.push({
                    //                         name: 'gscInvoiceDetail',
                    //                         query: {
                    //                             ispInvoiceId
                    //                         }
                    //                     })
                    //                 }
                    //             }
                    //         });
                    //     }
                    // },
                    {
                        title: this.$t('gscInvoice.t20'), // 取消
                        align: 'center',
                        minWidth: 50,
                        fixed: 'right',
                        key: 'invaccNum',
                        render: (h, params) => {
                            let {ispInvoiceId, status} = params.row;
                            return h('Button', {
                                props: {
                                    type: 'text',
                                    icon: 'trash-b',
                                    disabled: !['New', 'Rejected'].includes(status)
                                },
                                on: {
                                    click: () => {
                                        this.$Modal.confirm({
                                            content: this.$t('gscInvoice.t111'),
                                            onOk: () => {
                                                this.cancel(ispInvoiceId);
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('gscInvoice.t21'), // 打印汇总
                        align: 'center',
                        minWidth: 50,
                        fixed: 'right',
                        key: 'invaccNum',
                        render: (h, params) => {
                            let {status} = params.row;
                            return h('Button',
                                {
                                props: {
                                    type: 'text',
                                    icon: 'printer',
                                    loading: this.printLoading,
                                    disabled: ['New', 'Invoice Cancelled'].includes(status)
                                },
                                on: {
                                    click: () => {
                                        this.printPdf(params.row.ispInvoiceId);
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('gscInvoice.t22'), // 附件
                        align: 'center',
                        minWidth: 150,
                        fixed: 'right',
                        key: 'invaccNum',
                        render: (h, params) => {
                            let {ispInvoiceId, status, accessoryUrl, accessoryName} = params.row;
                            let format = ['jpeg', 'jpg', 'png', 'gif', 'pdf', 'rar', 'zip', '7z'];
                            let disabled = !['Submitted', 'Rejected'].includes(status);
                            let upload = h('Upload', {
                                props: {
                                    action: '/gscint/supplierfile/uploadFile',
                                    format,
                                    showUploadList: false,
                                    onSuccess: (response, file) => {
                                        let {fileName, docId} = response.data;
                                        axios.post('/gscint/hw/ispInvoice/uploadFile', {
                                            accessoryName: fileName,
                                            accessoryUrl: docId,
                                            ispInvoiceId: ispInvoiceId,
                                            vendorCode: this.vendorCode
                                        }).then(res => {
                                            if (res.data.data.code === 1) {
                                                this.$Modal.success({
                                                    content: this.$t('fpzInvaccSearch.t19') // 上传成功
                                                });
                                                this.onSubmit();
                                            } else {
                                                this.showErrorTips('loading', res.data.data.message);
                                            }
                                        });
                                    },
                                    onFormatError: () => {
                                        this.$Modal.error({
                                            // 附件只支持 xxx 格式
                                            content: `${this.$t('fpzInvaccSearch.t20')}${format.join()}${this.$t('fpzInvaccSearch.t21')}`
                                        });
                                    }
                                }
                            },
                            [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        icon: 'upload',
                                        disabled
                                    }
                                })
                            ]);
                            if (!accessoryUrl) {
                                return upload;
                            } else {
                                return h('div', {}, [
                                    h('a', {
                                        attrs: {
                                            href: `/gscint/supplierfile/downloadFile?docId=${accessoryUrl}`
                                        }
                                    }, [accessoryName]),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            icon: 'close',
                                            disabled
                                        },
                                        on: {
                                            click: () => {
                                                this.$Modal.confirm({
                                                    content: this.$t('fpzInvaccSearch.t22'), // 是否删除附件？
                                                    onOk: () => {
                                                        const url = '/gscint/hw/ispInvoice/uploadFile';
                                                        axios.post(url, {
                                                            accessoryName,
                                                            accessoryUrl,
                                                            ispInvoiceId,
                                                            vendorCode: this.vendorCode,
                                                            uploadFlag: 'del'
                                                        })
                                                        .then(res => {
                                                            if (res.data.data.success) {
                                                                setTimeout(() => {
                                                                    this.$Modal.success({
                                                                        content: this.$t('fpzInvaccSearch.t23') // 删除成功
                                                                    });
                                                                }, 500);
                                                                this.onSubmit();
                                                            }
                                                        })
                                                        .catch(() => {
                                                            this.showErrorTips();
                                                        });
                                                    }
                                                });
                                            }
                                        }
                                    })
                                ]);
                            }
                        }
                    },
                    {
                        title: this.$t('gscInvoice.t23'), // 录入税控发票
                        align: 'center',
                        minWidth: 70,
                        fixed: 'right',
                        key: 'button',
                        render: (h, params) => {
                            let {status, ispInvoiceId} = params.row;
                            let disabled = !['Submitted', 'Rejected'].includes(status);
                            return h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small',
                                    disabled
                                },
                                on: {
                                    click: () => {
                                        this.$router.push({
                                            name: 'gscInvoiceEdit',
                                            query: {
                                                ispInvoiceId
                                            }
                                        })
                                    }
                                }
                            }, this.$t('gscInvoice.t24'));
                        }
                    },
                    {
                        title: this.$t('gscInvoice.t90'),
                        align: 'center',
                        minWidth: 50,
                        fixed: 'right',
                        key: 'invaccNum',
                        render: (h, params) => {
                            let {ispInvoiceId, status, previousStatus, taxInvoiceNumber} = params.row;
                            return h('Button', {
                                props: {
                                    type: 'text',
                                    icon: 'checkmark',
                                    disabled: !((previousStatus === 'Tax Invoice Issued' && status === 'Rejected') || status === 'Submitted') || !taxInvoiceNumber
                                    
                                },
                                on: {
                                    click: () => {
                                        this.submitIsp(ispInvoiceId);
                                    }
                                }
                            })
                        }
                    }
                ]
            },
            tableData: [],
            tableButtons: {
                customButtons: [
                    {
                        label: this.$t('gscInvoice.t25'), // 更新价格
                        type: 'primary',
                        icon: 'archive',
                        loading: false,
                        disabled: false,
                        size: 'small',
                        click: (button) => {
                            this.updatePriceModal.show = true;
                        }
                    },
                    {
                        label: this.$t('gscInvoice.t26'), // 创建GSC发票
                        type: 'primary',
                        icon: 'archive',
                        loading: false,
                        disabled: false,
                        size: 'small',
                        click: (button) => {
                            this.$router.push({
                                name: 'gscInvoiceAdd'
                            });
                        }
                    },
                    {
                        label: this.$t('gscInvoice.t27'), // 导出
                        type: 'primary',
                        icon: 'archive',
                        loading: false,
                        disabled: false,
                        size: 'small',
                        click: (button) => {
                            if (this.$refs.pageForm.$children[0].$children[0].validateForm()) {
                                this.$set(button, 'loading', true);
                                exportExcel(button, this, this.getFormDataVModel(this.formData.items), '/gscint/hw/ispInvoice/exportHeaders')
                            }
                        }
                    },
                ]
            },
            loading: false,
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 20, 50, 100],
                needSearch: true,
                needValidation: true,
                currentPage: 1,
                pageSize: 10,
                total: null,
                submitLoading: false
            },
            updatePriceModal: {
                show: false,
                loading: false,
                form: {
                    orgId: '',
                    vendorSiteId: '',
                    currencyCode: ''
                },
                rules: {
                    orgId: [
                        {required: true, message: this.$t('gscInvoice.t30'), trigger: 'change', type: 'string'}
                    ],
                    vendorSiteId: [
                        {required: true, message: this.$t('gscInvoice.t30'), trigger: 'change', type: 'number'}
                    ],
                    currencyCode: [
                        {required: true, message: this.$t('gscInvoice.t30'), trigger: 'change'}
                    ]
                }
            },
            ouList: [],
            siteList: [],
            currencyList: [],
            INT_GSC_INVOICE_STATUS: [],
            INT_GSC_INVOICE_SOURCE_TYPE: [],
            printLoading: false,
            offsetTime: 0
        }
    },
    methods: {
        onSubmit () {
            this.loading = true;
            let {currentPage, pageSize} = this.settings;
            axios.post('/gscint/hw/ispInvoice/queryHeaders', {
                ...this.getFormDataVModel(this.formData.items),
                vendorCode: this.vendorCode,
                pageNum: currentPage,
                pageSize
            })
            .then(res => {
                this.loading = false;
                let {list, total} = res.data.data;
                this.tableData = list;
                this.settings.total = total;
                queryIntTimeZone(this.getFormDataVModel(this.formData.items).orgId, (data) => {
                    this.offsetTime = data;
                });
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        onPageSizeChange (currentPage, pageSize) {
            this.settings.currentPage = 1;
            this.settings.pageSize = pageSize;
            this.onSubmit();
        },
        onPageChange (currentPage, pageSize) {
            this.settings.currentPage = currentPage;
            this.onSubmit();
        },
        updatePriceConfirm (reallyExecute = null) {
            this.$refs.updatePriceForm.validate((valid) => {
                if (valid) {
                    let {orgId} = this.updatePriceModal.form;
                    this.updatePriceModal.loading = true;
                    axios.post('/gscint/hw/ispInvoice/uploadPrice', {
                        vendorCode: this.vendorCode,
                        orgId,
                        reallyExecute
                    })
                    .then((res) => {
                        this.updatePriceModal.loading = false;
                        let {code, message} = res.data.data;
                        if (code === 1) {
                            this.updatePriceModal.show = false;
                            this.$Modal.success({
                                content: this.$t('gscInvoice.t95')
                            });
                        } else if (code === 301) {
                            this.$Modal.confirm({
                                content: this.$t('gscInvoice.t109'),
                                onOk: () => {
                                    this.updatePriceConfirm('Y');
                                }
                            });
                        } else {
                            this.showErrorTips('loading', message);
                        }
                    })
                    .catch(() => {
                        this.updatePriceModal.loading = false;
                        this.showErrorTips();
                    });
                }
            })
        },
        changeOU (val) {
            // if (val) {
            //     queryVendorSite(val, this.vendorCode)
            //     .then((res) => {
            //         debugger;
            //     });
            // }
        },
        submitIsp (ispInvoiceId) {
            this.loading = true;
            axios.post('/gscint/hw/ispInvoice/submit', {
                ispInvoiceId,
                vendorCode: this.vendorCode
            })
            .then((res) => {
                this.loading = false;
                let {code, message} = res.data.data;
                if (code === 1) {
                    this.$Modal.success({
                        content: this.$t('gscInvoice.t101')
                    });
                    this.onSubmit();
                } else {
                    this.showErrorTips('loading', message);
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        cancel (ispInvoiceId) {
            this.loading = true;
            axios.post('/gscint/hw/ispInvoice/cancel', {
                ispInvoiceId,
                vendorCode: this.vendorCode
            })
            .then((res) => {
                this.loading = false;
                let {code, message} = res.data.data;
                if (code === 1) {
                    this.$Modal.success({
                        content: this.$t('gscInvoice.t110')
                    });
                    this.onSubmit();
                } else {
                    this.showErrorTips('loading', message);
                }
            });
        },
        printPdf (ispInvoiceId) {
            this.printLoading = true;
            axios.post('/gscint/hw/ispInvoice/queryForPrint', {
                ispInvoiceId,
                vendorCode: this.vendorCode
            })
            .then((res) => {
                let {data, code, message} = res.data.data;
                if (code === 1) {
                    this.cloudPrint('ispTotalPrintNew-hw', {reportlets: {
                        ...data
                    }})
                    .then(() => {
                    this.printLoading = false;
                    })
                    .catch(() => {
                        this.printLoading = false;
                    });
                } else {
                    this.showErrorTips('printLoading', message);
                }
            })
            .catch(() => {
                this.printLoading = false;
                this.showErrorTips();
            });
        }
    },
    mounted() {
        getOuList((data) => {
            this.getFormDataItemObj(this.formData.items, 'orgId').options.values = data;
            this.ouList = data;
        });
        /* 开票类型 */
        this.getDict('INT_GSC_INVOICE_SOURCE_TYPE', (data) => {
            data.forEach((item) => {
                item.value = item.code;
            });
            this.getFormDataItemObj(this.formData.items, 'invoiceType').options.values = data;
        });
        /* 币种 */
        this.getDict('INT_CURRENCY', (data) => {
            this.currencyList = data;
        });
        /* 状态 */
        this.getDict('INT_GSC_INVOICE_STATUS', (data) => {
            this.getFormDataItemObj(this.formData.items, 'status').options.values = data;
        });
    },
    activated () {
        this.onSubmit();
    }
}
</script>